import * as React from "react"
import { StaticQuery, graphql } from "gatsby"
import {FooterNavigation} from "../helpers/navigation"
import parse from "html-react-parser"

const Footer = ({useSimpleFooter}) => {

    const getSocialLinks = () => {
        return (
            <>
                <h3>JOIN US ON SOCIAL</h3>
                <ul className="social-link">
                    <li>
                        <a href="https://www.linkedin.com/company/cordiance/" target="_blank" rel="noreferrer" className="linkedin" aria-label="LinkedIn"><i
                            className="fa-brands fa-linkedin-in"></i></a>
                    </li>
                    <li>
                        <a href="https://twitter.com/iModios" target="_blank" rel="noreferrer" className="twitter" aria-label="Twitter"><i
                            className="fa-brands fa-twitter"></i></a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/Cordiance" target="_blank" rel="noreferrer" className="facebook" aria-label="Facebook"><i
                            className="fa-brands fa-facebook-f"></i></a>
                    </li>
                </ul>
            </>
        )
    }

    return (
        <StaticQuery
            query={graphql`{
                craftFooterGlobalSet {
                    footerLogo {
                        url
                        alt
                    }
                    footerTagline
                    footerInfographic {
                        url
                        alt
                    }
                    footerDescription
                }
                columnTwoNavigation: allCraftFooterColumnTwoNavigationNode(filter: {level: {eq: 1}}) {
                    nodes {
                        __typename
                        key: uid
                        nodeUri
                        title
                        enabled
                        typeLabel
                        remoteChildren {
                            __typename
                            key: uid
                            nodeUri
                            title
                            enabled
                            typeLabel
                        }
                    }
                }
                columnThreeNavigation: allCraftFooterColumnThreeNavigationNode(filter: {level: {eq: 1}}) {
                    nodes {
                        __typename
                        key: uid
                        nodeUri
                        title
                        enabled
                        typeLabel
                        remoteChildren {
                            __typename
                            key: uid
                            nodeUri
                            title
                            enabled
                            typeLabel
                        }
                    }
                }
            }`}
            render={data => (
                <>
                    {!useSimpleFooter &&
                        <footer>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="footer-left">
                                            <div className="footer-img">
                                                <img width="384" height="54" src={data.craftFooterGlobalSet.footerLogo[0].url} alt={data.craftFooterGlobalSet.footerLogo[0].alt} />
                                            </div>

                                            {data.craftFooterGlobalSet.footerTagline &&
                                                <div className="footer-text mb-30">
                                                    <p>{data.craftFooterGlobalSet.footerTagline}</p>
                                                </div>
                                            }

                                            {data.craftFooterGlobalSet.footerInfographic && data.craftFooterGlobalSet.footerInfographic.length > 0 &&
                                                <img width="1681" height="784" src={data.craftFooterGlobalSet.footerInfographic[0].url} alt={data.craftFooterGlobalSet.footerInfographic[0].alt} className="mb-30" />
                                            }

                                            <div className="about-text">
                                                {data.craftFooterGlobalSet.footerDescription &&
                                                    parse(data.craftFooterGlobalSet.footerDescription)
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        {FooterNavigation(data.columnTwoNavigation.nodes)}
                                    </div>
                                    <div className="col-md-4">
                                        {FooterNavigation(data.columnThreeNavigation.nodes)}
                                        {getSocialLinks()}
                                    </div>
                                </div>
                            </div>
                        </footer>
                    }
                    <div className="footer-bottom">
                        <div className="container text-center">
                            <div className="footer-info">©{(new Date().getFullYear())} Cordiance LLC. All rights reserved. | <a href="/">www.cordiance.com</a> | <a href="/privacy">Privacy</a></div>
                        </div>
                    </div>
                </>
            )}
        />
    )
}

export default Footer